module.exports = __webpack_public_path__ + "img/info-card-icon.02b5e48b.svg";